/* cm-motion.js — tiny driver for cm-motion.css (owner 2026-10-23). No libraries.
   - waits for load + 2 s, then adds html.cm-mo-run (CSS animations start only then)
   - pauses every motion while the tab is hidden (--cm-mo-state)
   - PDP: the first size click stops the shakes and fires one extra pulse (html.cm-mo-once for 1.3 s)
   - hero / banner CTAs animate only while on screen (IntersectionObserver -> .cm-mo-in)
   - card badges ("New", discount) bounce once when their card enters view
   Everything is skipped for prefers-reduced-motion, html.no-motion and automated browsers (see below). */
(function () {
  'use strict';
  var root = document.documentElement;
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if ((mq && mq.matches) || root.classList.contains('no-motion')) return;
  /* Automated browsers (WebDriver: Playwright / Selenium / e2e testers) get NO motion unless the URL
     carries ?cm_motion=1 (remembered for the session). Reason: an element that never stops scaling or
     shaking can never be "stable", so a scripted click on Add to cart / Buy it now would time out.
     Real shoppers (navigator.webdriver false) are unaffected. */
  var force = false;
  try {
    if (/[?&]cm_motion=1(&|$)/.test(location.search)) sessionStorage.setItem('cm_motion', '1');
    force = sessionStorage.getItem('cm_motion') === '1';
  } catch (e) {}
  if (navigator.webdriver && !force) return;
  var hasIO = 'IntersectionObserver' in window;

  function setState() {
    root.style.setProperty('--cm-mo-state', document.hidden ? 'paused' : 'running');
  }
  document.addEventListener('visibilitychange', setState);
  setState();
  if (mq && mq.addEventListener) {
    mq.addEventListener('change', function () { if (mq.matches) root.classList.remove('cm-mo-run'); });
  }

  /* ---- PDP: first size choice stops the shake, one extra pulse invites the click ---- */
  var onceTimer = 0;
  function sized() {
    if (root.classList.contains('cm-mo-sized')) return;
    root.classList.add('cm-mo-sized', 'cm-mo-once');
    clearTimeout(onceTimer);
    onceTimer = setTimeout(function () { root.classList.remove('cm-mo-once'); }, 1300);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.cm-vpick__opt, [data-cm-opt]')) sized();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-cm-sticky-select], .cm-vpick__opt input, [data-cm-opt] input')) sized();
  }, true);

  /* ---- CTAs: animate only while visible ---- */
  var ctaIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.classList.toggle('cm-mo-in', en.isIntersecting); });
  }, { threshold: 0.2 }) : null;

  /* ---- badges: one bounce when the card scrolls into view ---- */
  var badgeIO = hasIO ? new IntersectionObserver(function (entries, io) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var b = en.target;
      io.unobserve(b);
      b.classList.add('cm-mo-bounce');
      b.addEventListener('animationend', function () { b.classList.remove('cm-mo-bounce'); }, { once: true });
    });
  }, { threshold: 0.6 }) : null;

  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function scan(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var i, list;
    if (ctaIO) {
      list = scope.querySelectorAll('.cm-hero__cta, .cm-banner__cta');
      for (i = 0; i < list.length; i++) if (!seen.has(list[i])) { seen.add(list[i]); ctaIO.observe(list[i]); }
    }
    if (badgeIO) {
      list = scope.querySelectorAll('.cm-card .cm-badge--new, .cm-card .cm-badge--sale');
      for (i = 0; i < list.length; i++) if (!seen.has(list[i])) { seen.add(list[i]); badgeIO.observe(list[i]); }
    }
    if (starIO) {
      list = scope.querySelectorAll('.cm-rating__stars');
      for (i = 0; i < list.length; i++) if (!seen.has(list[i])) { seen.add(list[i]); starIO.observe(list[i]); }
    }
  }

  function start() {
    root.classList.add('cm-mo-run');
    scan(document);
    /* infinite scroll / filters / quick views add cards later: scan only the added subtrees */
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var m = 0; m < muts.length; m++) {
          var add = muts[m].addedNodes;
          for (var k = 0; k < add.length; k++) if (add[k].nodeType === 1) scan(add[k]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }


  /* ---- round 9 (owner 2026-10-24): stars fill left -> right once when visible (0.6 s) ---- */
  var starIO = hasIO ? new IntersectionObserver(function (entries, io) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      fillStars(en.target);
    });
  }, { threshold: 0.6 }) : null;
  function fillStars(el) {
    /* the row is a masked gold star strip: a temporary gradient fills it left -> right, then the inline style is removed */
    var start = 0;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / 600);
      var e = 1 - Math.pow(1 - p, 3);
      el.style.background = 'linear-gradient(to right,#F5A623 ' + (e * 100).toFixed(1) + '%,#e5e7eb ' + (e * 100).toFixed(1) + '%)';
      if (p < 1) requestAnimationFrame(step);
      else el.style.background = '';
    }
    requestAnimationFrame(step);
  }

  /* ---- size buttons: press feedback (scale .95) also when :active is not reported (pointer fallback) ---- */
  function pressOn(e) {
    var o = e.target && e.target.closest ? e.target.closest('.cm-vpick__opt') : null;
    if (o) o.classList.add('cm-mo-press');
  }
  function pressOff() {
    var list = document.querySelectorAll('.cm-vpick__opt.cm-mo-press');
    for (var i = 0; i < list.length; i++) list[i].classList.remove('cm-mo-press');
  }
  document.addEventListener('pointerdown', pressOn, true);
  document.addEventListener('pointerup', pressOff, true);
  document.addEventListener('pointercancel', pressOff, true);
  document.addEventListener('pointerleave', pressOff, true);

  /* ---- round 9: add to cart success = label morph (1.2 s), thumbnail flies to the cart, cart bounces, count pops ---- */
  var ADDED_TXT = (document.documentElement.lang || '').slice(0, 2) === 'ar' ? '✓ اتضافت للسلة' : '✓ Added';
  var lastAdd = null;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cm-atc-btn]') : null;
    if (b) lastAdd = b;
  }, true);
  function morphAdded(btn) {
    var lab = btn.querySelector('.cm-atc__label');
    if (!lab) return;
    if (!btn.hasAttribute('data-cm-mo-orig')) btn.setAttribute('data-cm-mo-orig', lab.textContent);
    lab.textContent = ADDED_TXT;
    btn.classList.add('cm-mo-added');
    clearTimeout(btn.__moT);
    btn.__moT = setTimeout(function () {
      btn.classList.remove('cm-mo-added');
      var orig = btn.getAttribute('data-cm-mo-orig');
      if (orig != null) lab.textContent = orig;
    }, 1200);
  }
  function bounceCart() {
    var cart = document.querySelector('.cm-header__cart');
    if (cart) { cart.classList.remove('cm-mo-cart'); void cart.offsetWidth; cart.classList.add('cm-mo-cart'); }
    var c = document.querySelector('.cm-header__count');
    if (c) { c.classList.remove('cm-mo-pop'); void c.offsetWidth; c.classList.add('cm-mo-pop'); }
  }
  function flyThumb(btn) {
    var cart = document.querySelector('.cm-header__cart');
    /* the product photo that was bought (first gallery image with a source), wherever it sits on the page */
    var img = null, imgs = document.querySelectorAll('.cm-gallery__img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].currentSrc || imgs[i].src) { img = imgs[i]; break; }
    }
    var src = img && (img.currentSrc || img.src);
    if (!cart || !src || !btn || !btn.isConnected) { bounceCart(); return; }
    var f = btn.getBoundingClientRect(), t = cart.getBoundingClientRect();
    if (!f.width || !t.width) { bounceCart(); return; }
    var el = document.createElement('div');
    el.className = 'cm-mo-fly';
    el.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
    el.style.left = (f.left + f.width / 2 - 24) + 'px';
    el.style.top = (f.top + f.height / 2 - 24) + 'px';
    document.body.appendChild(el);
    var dx = (t.left + t.width / 2) - (f.left + f.width / 2);
    var dy = (t.top + t.height / 2) - (f.top + f.height / 2);
    var anim = el.animate([
      { transform: 'translate(0px,0px) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 70) + 'px) scale(.7)', opacity: 0.95, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.2)', opacity: 0.2 }
    ], { duration: 700, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
    anim.onfinish = function () { el.remove(); bounceCart(); };
  }
  document.addEventListener('cm:cart:updated', function () {
    var btn = lastAdd;
    if (!btn || !btn.isConnected) return;
    morphAdded(btn);
    flyThumb(btn);
  });

  function arm() { setTimeout(start, 2000); }
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm, { once: true });
})();
